import { makeStorageInterface } from "utils/hooks/useWindowStorage";

export const LITERATI_USER_STORAGE_KEY = "LITERATI_USER";

export interface LiteratiUser {
  id: number;
  first_name: string;
  last_name: string;
}

/**
 * `sessionStorage` is client-only, so server-side we pass no storage at all and
 * `makeStorageInterface`'s optional calls make every operation a no-op. Same
 * fallback behavior as `useWindowStorage`, without needing the React context.
 *
 * Invariant: this key exists only while the customer is authenticated. Every
 * code path that learns otherwise must call `clearLiteratiUser`.
 */
const storage = () =>
  makeStorageInterface<typeof LITERATI_USER_STORAGE_KEY>({
    storage: typeof window === "undefined" ? undefined : window.sessionStorage,
  });

export function setLiteratiUser(user: LiteratiUser) {
  storage().setItem(LITERATI_USER_STORAGE_KEY, user);
}

/**
 * The stored value is written by the browser and is trivially editable from
 * devtools. Treat it as a display cache -- never authorize on it.
 */
export function getLiteratiUser() {
  return storage().getItem<LiteratiUser>(LITERATI_USER_STORAGE_KEY);
}

export function clearLiteratiUser() {
  storage().removeItem(LITERATI_USER_STORAGE_KEY);
}
